import { useLocation } from 'react-router-dom';
import { ReactComponent as ArrowExpandIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function PanelHeader({ slug, title, subTitle, disabled }) {
  const { search } = useLocation();
  const isDisabled = disabled || !slug;

  if (isDisabled) {
    return (
      <div className="mb-2.5 flex w-full items-end justify-between">
        <h2 className="flex items-center text-base font-semibold text-black-pearl-500">{title}</h2>
        <span className="text-sm font-semibold text-black-pearl-500">{subTitle}</span>
      </div>
    );
  }
  return (
    <div className="mb-2.5 flex w-full items-end justify-between">
      <h2 className="m-0 p-0">
        <AppLink
          to={{
            pathname: `/web-analytics/${slug}`,
            search,
          }}
          className="flex items-center text-base font-semibold text-black-pearl-500 cursor-pointer"
        >
          {title}
          <ArrowExpandIcon
            className="ml-2.5 h-2.5 w-2.5 rotate-90 fill-current opacity-50"
            aria-hidden="true"
            aria-label="expand"
            focusable="false"
          />
        </AppLink>
      </h2>
      <span className="text-sm font-semibold text-black-pearl-500">{subTitle}</span>
    </div>
  );
}
